export enum CustomIdSchemeFields {
    PATTERN = 'pattern',
    DESCRIPTION = 'description',
    TARGET = 'target',
    COUNTER = 'counter',
    IS_DEFAULT = 'isDefault',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}
